import { useSessionStorageState } from '../../hooks/useSessionStorageState';

export type AdminRole = 'SUPER_ADMIN' | 'ADMIN';
export type AdminStatus = 'PENDING' | 'APPROVED';

export interface AdminProfile {
  id: number;
  username: string;
  role: AdminRole;
  name: string | null;
}

export interface AdminSession {
  token: string;
  admin: AdminProfile;
}

export const ADMIN_ROLE_LABEL: Record<AdminRole, string> = {
  SUPER_ADMIN: '최종관리자',
  ADMIN: '일반관리자',
};

export const ADMIN_STATUS_LABEL: Record<AdminStatus, string> = {
  PENDING: '승인 대기',
  APPROVED: '승인됨',
};

export function useAdminSession() {
  return useSessionStorageState<AdminSession | null>('adminSession', null);
}
